<template>
  <div class="modal" v-if="seen">
    <div class="deletefile" style="width: 520px;" v-if="!loader">
      <span @click="closebox" class="closefile">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="#000000"
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </span>
      <div class="header">
        <h3>Delete File</h3>
      </div>
      <div class="cgn">
        <span class="text-head">
          <strong>Are you sure you want to delete</strong>
        </span>
        <ul class="selected_files">
          <li>
            <span>
              <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                <path fill="#0c0" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
              </svg>
            </span>
            &nbsp;
            {{ str_text(name) }}
          </li>
        </ul>
      </div>
      <div class="save">
        <span @click="permanent">
          <svg style="width:14px;height:14px" viewBox="0 0 24 24">
            <path fill="#fff"
              d="M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z" />
          </svg>
          Delete file
        </span>
      </div>
    </div>
    <div class="permanent" v-if="loader">
      <span>Deleting <strong>{{ str_text(name) }}</strong> permanently</span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
  </div>
</template>
<style scoped>
.loading {
  display: flex;
  align-items: center;
  height: 160px !important;
}

.selected_files li>span {
  margin-bottom: 0;
}

.selected_files li {
  display: flex;
  align-items: center;
  padding: .5em .3em;
}

.cgn {
  display: flex;
  flex-direction: column;
}

span.text-head {
  margin-bottom: 2em;
}

.cgn span {
  margin-bottom: .5em;
}
</style>
<script>
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      prompt: ''
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 30 ? str.substr(0, 30) + '...' : str
    },
    load(index, prompt) {
      this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
      this.seen = true
      this.index = index
      this.id = this.$store.getters.DIRECTORY_CHILDREN[index].id

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        file_id: this.id
      };

      if (prompt === '') {
        this.$socket.emit('deletepermanently', data, function (data) {
          if (data.message === 'completed') {
            that.seen = false
            let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
            that.UPDATE_TOTAL_USED_SPACE(total_space_used)
            that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
          }

          if (data.data === false) {
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }
        })
      }
    },
    permanent() {
      let data = {
        token: cookies.getCookie('token'),
        file_id: this.id,
        delete_type: true
      };

      let that = this

      this.loader = true

      this.$socket.emit('deletepermanently', data, function (data) {
        if (data.message === 'completed') {
          that.loader = false
          that.seen = false
          let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          that.UPDATE_TOTAL_USED_SPACE(total_space_used)
          that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
        }

        if (data.data === false) {
          that.seen = false
          that.loader = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
      this.loader = false
    }
  }
}
</script>
